import React, { FC, useCallback, useMemo } from "react"

import { Dialog } from "src/components/common/dialog"
import { BasicLayoutStyleProps } from "src/components/layouts/basic"

import {
  useBookingDetailPermissions,
  mergeBookingDetailPermissions,
  resetBookingDetailPermissions,
} from "src/states/bookingDetailPermissions"

import { mergeDialog } from "src/states/dialogs"
import { TranslationMessages } from "src/translations"

import { PermissionTable } from "./PermissionTable"

export type PermissionDialogProps = {
  messages: TranslationMessages
  style: BasicLayoutStyleProps
}

export const PermissionDialog: FC<PermissionDialogProps> = ({
  messages,
  style,
}) => {
  const m = messages.pages.booking.detail.actions.permissions
  const { open } = useBookingDetailPermissions()

  const handleCancel = useCallback(() => {
    mergeDialog("salesorderDialog", { open: true })
    resetBookingDetailPermissions()
  }, [])

  return (
    <Dialog
      closeOnClick
      fullWidth
      maxWidth="xl"
      open={useMemo(() => open, [open])}
      style={style}
      title={m.title}
      firstRowButtons={[
        {
          title: m.cancel,
          variant: "text",
          onClick: handleCancel,
        },
      ]}
      onClose={() =>
        mergeBookingDetailPermissions({
          open: !open,
        })
      }
    >
      <PermissionTable messages={messages} />
    </Dialog>
  )
}
